export default {"src":"/_next/static/media/light-warning-icon.f57fec75.svg","height":11,"width":12};